module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-style/i1-1-fe581cc1cd294e795bb7792c18d6057f.svg";